import axios from 'axios';

const fetchProducts = async () => {
    try {
        const response = await axios.get('/api/shop/v1/products')
        return response.data
    } catch (err) {
        throw (err)
    }
};

const fetchCategories = async () => {
    try {
        const response = await axios.get('/api/shop/v1/categories')
        return response.data
    } catch (err) {
        throw (err)
    }
};

const getOrderInfo = async (uuid) => {
    try {
        const response = await axios.get(`/api/shop/v1/order/${uuid}`)
        return response.data
    } catch (err) {
        throw (err)
    }
}

const createTableOrder = async (order) => {
    try {
        const response = await axios.post('/api/shop/v1/order/create/table', order)
        return response.data
    } catch (err) {
        throw (err)
    }
} 

const createOnlineOrder = async (order) => {
    try {
        const response = await axios.post('/api/shop/v1/order/create/online', order)
        return response.data
    } catch (err) {
        throw (err)
    }
} 

const updateTableOrder = async (order, uuid) => {
    try {
        const response = await axios.put(`/api/shop/v1/order/update/${uuid}`, order)
        return response.data
    } catch (err) {
        throw (err)
    }
}

const leftOrderReview = async (uuid, review) => {
    try {
        const response = await axios.post(`/api/shop/v1/order/review/${uuid}/add`, { review })
        return response.data
    } catch (err) {
        throw (err)
    }
}

const billRequest = async (tableId, uuid) => {
    try {
        const response = await axios.post('/api/shop/v1/calls/bill', {
            table_id: tableId,
            order_uuid: uuid
        })
        return response.data
    } catch (err) {
        throw (err)
    }
}


export {
    fetchProducts,
    getOrderInfo,
    createTableOrder,
    fetchCategories,
    updateTableOrder,
    billRequest,
    createOnlineOrder,
    leftOrderReview
}